import React, { useState, useEffect } from 'react'
import { Form, Input, message, Modal, Radio, Button, Flex } from 'antd'
import { useYonghuAddMutation, useYonghuAddCodeMutation } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
function UserAdd(props) {    
    const [form] = Form.useForm(); 
    const [submit] = useYonghuAddMutation();
    const [yonghuAddCode] = useYonghuAddCodeMutation();
    const [info,setInfo] = useState({
        'yh_name': '',
        'yh_phone': '',
        'yh_qx': '',
        'yh_state': '1',
        'yh_qy_id': props.qy_id,
        'yh_uid': props.yh_id,
        'yh_uname': props.yh_name,
        'yh_qy_name': props.qy_name,
        'yh_juese': '财务',
    })
    const [open, setOpen] = useState(false);
    const [smsCooldown, setSmsCooldown] = useState(0);
    const [smsSending, setSmsSending] = useState(false);
    useEffect(() => {
        if (smsCooldown <= 0) return;
        const t = setTimeout(() => setSmsCooldown((c) => c - 1), 1000);
        return () => clearTimeout(t);
    }, [smsCooldown]);

    const handleSendSms = () => {
        if (smsCooldown > 0 || smsSending) return;
        form.validateFields(['yh_phone'])
            .then(() => {
                const phone = form.getFieldValue('yh_phone');
                setSmsSending(true);
                return yonghuAddCode({ phone });
            })
            .then((res) => {
                if (res.data?.Status === 'success') {
                    message.success('验证码已发送');
                    setSmsCooldown(60);
                } else {
                    message.error(res.data?.Message ? String(res.data.Message) : '发送验证码失败');
                }
            })
            .catch((err) => {
                if (err?.errorFields) {
                    message.warning('请先正确填写登录手机号码');
                } else {
                    message.error('发送验证码失败，请稍后重试'+(err.response?.data?.Message||''));
                }
            })
            .finally(() => setSmsSending(false));
    };

    return (
        <>
            <Icon type='add' onClick={() => {setOpen(true)}} />
            <Modal
                open={open}
                title='新增操作员'
                onCancel={() => {setOpen(false)}}
                onOk={() => {                    
                    submit(info).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功')   
                            form.resetFields();  
                            setOpen(false);
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败：'+res.data.Message)
                        }
                    }) 
                }}            
            >
                <Form                                
                    form={form}
                    style={{width: '100%' }}
                    layout="horizonal"
                    name="form_user"
                    initialValues={{
                        modifier: 'public',
                    }}
                    labelCol={{ span: 6}}                                 
                >   
                    <Form.Item name="yh_name" wrapperCol={{span:10}} required label='姓名'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_name:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item name="yh_phone" wrapperCol={{span:10}} required label='登录手机号码'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_phone:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item label="短信验证码" required wrapperCol={{span:10}}>
                        <Flex gap={8} align="flex-start">
                            <Form.Item
                                name="code"
                                noStyle
                                rules={[
                                    { required: true, message: '请填写短信验证码' },
                                    { pattern: /^\d{4,6}$/, message: '验证码为4～6位数字' },
                                ]}
                            >
                                <Input
                                    placeholder="请输入短信验证码"
                                    maxLength={6}
                                    style={{ flex: 1 }}
                                    onChange={(e) => {
                                        setInfo(prevState=>({...prevState,phone_code:e.target.value}))
                                    }}
                                />
                            </Form.Item>
                            <Button
                                disabled={smsCooldown > 0 || smsSending}
                                loading={smsSending}
                                onClick={handleSendSms}
                                style={{ flexShrink: 0 }}
                            >
                                {smsCooldown > 0 ? `${smsCooldown}秒后重试` : smsSending ? '发送中…' : '获取验证码'}
                            </Button>
                        </Flex>
                    </Form.Item>
                    <Form.Item name="yh_mima" wrapperCol={{span:10}} required label='密码'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_mima:e.target.value}))
                        }}/>
                    </Form.Item>
                    <Form.Item name="yh_qx" wrapperCol={{span:10}} required label='权限'>                        
                        <Radio.Group onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_qx:e.target.value}))
                        }}>
                            <Radio value="业务">业务</Radio>        
                            <Radio value="管理">管理</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="yh_state" wrapperCol={{span:10}} required label='状态'>                        
                        <Radio.Group onChange={(e) => {
                            setInfo(prevState=>({...prevState,yh_state:e.target.value}))
                        }}>
                            <Radio value="1">启用</Radio>
                            <Radio value="2">禁用</Radio>
                        </Radio.Group>
                    </Form.Item>                       
                </Form>
            </Modal>
        </>
    )
}

export default UserAdd